import { Cancel } from '@mui/icons-material';
import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ClearAllButton } from './styles';

interface FilterFooterProps {
  handleClear: () => void;
}

export const FilterFooter = ({ handleClear }: FilterFooterProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        height: '64px',
        width: '100%',
        padding: (theme) => theme.spacing(0, 2),
        backgroundColor: (theme) => theme.palette.common.white,
        [theme.breakpoints.down('sm')]: {
          height: '50px',
        },
      }}
    >
      <ClearAllButton onClick={handleClear} startIcon={<Cancel />}>
        {t('common.filter.clear_all')}
      </ClearAllButton>
    </Box>
  );
};
